import React from "react";
import styled from "styled-components";
import get from "lodash/get";
import SectionTitle from "../../common/Section/SectionTitle";
import Theme from "../../../vars/ThemeOptions";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Wrap = styled.div`
  * {
    transition: all 0.3s ease;
  }
  padding: 2rem 0;
  b,
  ol {
    color: ${Theme.hex("primary")};
    font-weight: bold;
  }
  p {
    margin-bottom: 10px;
  }
`;

const HowToEnter = ({ data }) => {
  const richText1 = get(data, "richText1");
  const json = get(richText1, `json`);
  return (
    <Wrap>
      <SectionTitle
        title={() => <>{documentToReactComponents(json)}</>}
        titleColor="black"
        bold
      />
    </Wrap>
  );
};

export default HowToEnter;
